import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { OrderProposalService } from "../../../services/api/order-proposal.service";
import { OrderProposalActions } from "../../actions/order-proposal.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class CancelOrderProposalEffects {
	proposalCancelRequested = createEffect(() => {
		return this.actions.pipe(
			ofType(OrderProposalActions.cancelProposal.cancel),
			switchMap((action) => {
				return this.orderProposalService
					.cancelProposal({ id: action.id, reason: action.reason })
					.pipe(
						map(() =>
							OrderProposalActions.cancelProposal.cancelSuccess({ id: action.id })
						),
						catchError((error) =>
							of(OrderProposalActions.cancelProposal.cancelFail(new FailState(error)))
						)
					);
			})
		);
	});

	constructor(
		private actions: Actions,
		private orderProposalService: OrderProposalService
	) {}
}
